import ModalPortal from '@/components/ModalPortal/ModalPortal';
import EnercityAppButton from '@/page-templates/EnercityAppRedirectPage/EnercityAppButton';
import { BoxWidth } from '../Box/consts';
import EnercityAppIcon from '../EnercityAppIcon/EnercityAppIcon';
import { HeadlineLevel } from '../Headline/consts';
import Headline from '../Headline/Headline';
import ModalCloseIcon from '../Modal/ModalCloseIcon/ModalCloseIcon';
import ModalContent from '../Modal/ModalContent';
import Stack from '../Stack/Stack';
import styles from './AppModal.module.scss';
import type { AppModalProps } from './types';

const AppModal = ({
  id,
  handleClose,
  isVisible,
  headline = 'Jetzt enercity App laden!',
  text,
}: AppModalProps) => {
  return (
    <ModalPortal
      id={`app-modal-${id ?? headline}`}
      onClose={handleClose}
      show={isVisible}
      variant="shade"
      disableCloseIcon={true}
    >
      <ModalContent width={BoxWidth.SMedium}>
        <ModalCloseIcon onClick={handleClose} />

        <Stack gap={1} alignItems="center">
          <EnercityAppIcon className={styles.appIcon} />
          <Headline level={HeadlineLevel.Four}>{headline}</Headline>
          <p className={styles.text}>{text}</p>
          <div className={styles.marketplaceLinks}>
            <EnercityAppButton variant="ios" name="Apple App Store" />
            <EnercityAppButton variant="android" name="Google Play Store" />
          </div>
        </Stack>
      </ModalContent>
    </ModalPortal>
  );
};

export default AppModal;
